import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterChip } from '../components/FilterChip';
import { MediaPicker } from '../components/MediaPicker';
import { PageHeader } from '../components/PageHeader';
import { Button } from '../components/ui/Button';
import { Card, SectionTitle } from '../components/ui/Card';
import { categories } from '../data/topics';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
import type { SportCategory } from '../types';
const pulseKinds = categories.filter(item => item !== 'all');
export function CreatePulse() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const social = useSocial();
  const [media, setMedia] = useState<string | null>(null);
  const [kind, setKind] = useState<SportCategory>('workout');
  const [label, setLabel] = useState('');
  const [metric, setMetric] = useState('');
  const publish = () => {
    if (!media) return;
    social.publishPulse({
      media,
      kind,
      label: label.trim().length > 0 ? label.trim() : t(`category.${kind}`),
      metric: metric.trim() || undefined
    });
    navigate('/publicado/pulse', {
      replace: true
    });
  };
  return <div className="px-2 pb-2" data-id="element-2600" data-mp="28t52aco5vhz4">
      <PageHeader title={t('create.pulse.title')} subtitle={t('create.pulse.always')} showBack data-id="element-2601" data-mp="28q0smzrxfu12" />

      <Card className="p-2" data-id="element-2602" data-mp="2hsjubgjz80lq">
        <SectionTitle data-id="element-2603" data-mp="2hrqja3dzioxs">{t('create.media.title')}</SectionTitle>
        <MediaPicker value={media} onChange={setMedia} data-id="element-2604" data-mp="2dr6lqypi1jb4" />
      </Card>

      {media && <Card className="mt-2 p-2" data-id="element-2605" data-mp="2dpdp8c8lofgu">
          <SectionTitle data-id="element-2606" data-mp="2riuxv1zr07s3">{t('create.preview')}</SectionTitle>
          <div className="relative mx-auto h-[220px] w-[160px] overflow-hidden rounded-panel ring-2 ring-gold ring-offset-2 ring-offset-sand" data-id="element-2607" data-mp="2rkfrmpe8nmow">
            <img src={media} alt="" aria-hidden="true" className="h-full w-full object-cover" data-id="element-2608" data-mp="31fzkf2xia59f" />
            <span className="absolute inset-0 bg-deep/45" aria-hidden="true" data-id="element-2609" data-mp="2wihdtj6yo24l" />
            <div className="absolute bottom-2 left-2 right-2" data-id="element-2610" data-mp="33l62bhyxkg87">
              <p className="bee-overline text-[8.5px] font-bold text-gold" data-id="element-2611" data-mp="33ita8bzgkphf">
                {t(`category.${kind}`)}
              </p>
              <p className="mt-[2px] truncate text-[12.5px] font-bold text-sand" data-id="element-2612" data-mp="3djc1hrtcr89d">
                {label.trim().length > 0 ? label : t(`category.${kind}`)}
              </p>
              {metric.trim().length > 0 && <p className="bee-num truncate text-[10.5px] text-sand/85" data-id="element-2613" data-mp="3n9n9bpg5q1lj">{metric}</p>}
            </div>
          </div>
        </Card>}

      <Card className="mt-2 p-2" data-id="element-2614" data-mp="3rcbijy8s9aj1">
        <SectionTitle data-id="element-2615" data-mp="3w7r3j70gji">{t('create.context.title')}</SectionTitle>
        <p className="-mt-1 mb-2 text-[11px] text-muted" data-id="element-2616" data-mp="2ctfih3kfkd">{t('create.context.hint')}</p>

        <ul className="bee-rail -mx-2 flex gap-1 overflow-x-auto px-2 pb-1" data-id="element-2617" data-mp="516473501sgu">
          {pulseKinds.map(item => <li key={item} className="shrink-0" data-id="element-2618" data-mp="26ulyqb47jrh3">
              <FilterChip label={t(`category.${item}`)} active={kind === item} onClick={() => setKind(item)} data-id="element-2619" data-mp="26vexaot0jao5" />
            </li>)}
        </ul>

        <label className="mt-2 block" data-id="element-2620" data-mp="1uj31r8i274sx">
          <span className="bee-overline text-[9px] font-bold text-muted" data-id="element-2621" data-mp="1pl1juqwddbj1">
            {t('create.pulse.label')}
          </span>
          <input value={label} onChange={event => setLabel(event.target.value)} placeholder={t('create.pulse.labelHint')} className="mt-1 h-11 w-full rounded-card border border-sand-line bg-white/80 px-2 text-[13.5px] text-deep placeholder:text-muted focus:border-deep/40" data-id="element-2622" data-mp="1kn9gn0q9y2zj" />
        </label>

        <label className="mt-2 block" data-id="element-2623" data-mp="28dlwqyvob617">
          <span className="bee-overline text-[9px] font-bold text-muted" data-id="element-2624" data-mp="23dhd4zzgxv6r">
            {t('create.pulse.metric')}
          </span>
          <input value={metric} onChange={event => setMetric(event.target.value)} placeholder={t('create.pulse.metricHint')} className="mt-1 h-11 w-full rounded-card border border-sand-line bg-white/80 px-2 text-[13.5px] text-deep placeholder:text-muted focus:border-deep/40" data-id="element-2625" data-mp="wy6zdtzjyc5k" />
        </label>
      </Card>

      <Button variant="gold" size="lg" fullWidth className="mt-3" disabled={!media} onClick={publish} data-id="element-2626" data-mp="26ubwqh96cdop">
        {t('create.publishPulse')}
      </Button>
    </div>;
}